<template>
  <v-snackbar
    v-bind:color="alertType"
    v-bind:top="true"
    v-bind:timeout="timeout"
    v-model="visible"
  >
    <h3 v-if="alertTitle">{{ alertTitle }}</h3>
    {{ alertDescription }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" v-on:click="visible = false"> Chiudi </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "AlertSnackbar",

  props: {
    value: { type: Object, default: null },
    timeout: { type: Number, default: 3000 }
  },

  data: () => ({
    alert: {}
  }),

  computed: {
    // Get set snackbar visibility
    visible: {
      get: function () {
        return !!this.value;
      },
      set: function (value) {
        value === false && this.$emit("input", null);
      }
    },

    // Alert title
    alertType: function () {
      switch (this.alert.type) {
        case "warning":
        case "success":
        case "error":
          return this.alert.type;
        default:
          return "error";
      }
    },

    // Alert title
    alertTitle: function () {
      return this.alert.title || "";
    },

    // Alert description
    alertDescription: function () {
      return this.alert.description || "";
    }
  },

  watch: {
    value(value) {
      value && (this.alert = Object.assign({}, value));
    }
  }
};
</script>
